export const queryKeys = {
  promoCodes: {
    all: ["promoCodes"] as const,
    list: (options: object) => [...queryKeys.promoCodes.all, "list", options] as const,
  },
  webDownloads: {
    all: ["webDownloads"] as const,
    directory: (relativePath: string) => [...queryKeys.webDownloads.all, "directory", relativePath] as const,
  },
  adminTools: {
    all: ["adminTools"] as const,
    contentDuration: () => [...queryKeys.adminTools.all, "contentDuration"] as const,
    offlineDownloadsCount: () => [...queryKeys.adminTools.all, "offlineDownloadsCount"] as const,
    feedbackResults: () => [...queryKeys.adminTools.all, "feedbackResults"] as const,
  },
} as const;
